import React from 'react';
import { NavLink as Link } from 'react-router-dom';
import { LayoutContext } from 'components/layouts/LayoutContext';
import { PaginateProps } from '.';
import { PaginateItem } from './PaginateItem';

interface PageLinkProps extends PaginateProps {
  active?: boolean;
  page: number;
  resetScrollOnPageChange: boolean;
  onClick?: (e: React.MouseEvent) => void;
  children?: React.ReactNode;
}
export function PageLink({
  resetScrollOnPageChange = true,
  onClick,
  ...props
}: PageLinkProps) {
  const layoutContext = React.useContext(LayoutContext);

  const handleClick = React.useCallback(
    (e: React.MouseEvent) => {
      if (resetScrollOnPageChange && layoutContext?.layoutRef.current) {
        layoutContext?.layoutRef.current.scroll({ top: 0 });
      } else window.scroll({ top: 0 });
      if (onClick) {
        onClick && onClick(e);
      }
    },
    [layoutContext, onClick, resetScrollOnPageChange],
  );

  return (
    <PaginateItem className={props.active ? 'active' : undefined}>
      {props.active ? (
        <span>{props.page.toLocaleString()}</span>
      ) : (
        <Link to={props.href(props.page)} onClick={handleClick}>
          {props.children || props.page.toLocaleString()}
        </Link>
      )}
    </PaginateItem>
  );
}
